(function () {
  'use strict';

  var mobile = window.matchMedia('(max-width: 800px)');
  var products = [];
  var frame = 0;
  var tidio = null;
  var chatState = 'unknown';
  var chatHidden = false;
  var chatOpener = null;
  var chatShadow = null;
  var chatObserver = null;
  var chatOpening = false;

  function text(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function setText(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  function enhanceRadioFocus(root) {
    root.querySelectorAll('.product__color > input[type="radio"], .product__size > input[type="radio"]').forEach(function (input) {
      var label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL') label.removeAttribute('tabindex');
    });
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      observeChatState();
      var visible = false;
      var height = 0;
      products.forEach(function (product) {
        product.update();
        if (!product.bar.hidden) {
          visible = true;
          height = Math.max(height, product.bar.offsetHeight);
        }
      });
      document.body.classList.toggle('ad-product-buy-visible', visible);
      document.body.style.setProperty('--ad-product-buy-height', height + 'px');
    });
  }

  function chatBlocksPurchaseBar() {
    return chatOpening || chatState === 'open' || (chatState === 'unknown' && (!!tidio || !!document.getElementById('tidio-chat')));
  }

  function updateChatButtons() {
    document.querySelectorAll('[data-ad-product-chat-container]').forEach(function (container) {
      container.hidden = !tidio || !mobile.matches;
    });
    document.querySelectorAll('[data-ad-product-chat]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(chatState === 'open'));
    });
  }

  function applyChatVisibility() {
    if (!tidio) return;
    if (!mobile.matches || chatState === 'open' || !document.querySelector('[data-ad-product-chat]')) {
      if (chatHidden) {
        chatHidden = false;
        tidio.show();
      }
    } else if (chatState === 'closed' && !chatHidden) {
      chatHidden = true;
      tidio.hide();
    }
    updateChatButtons();
  }

  function observeChatState() {
    if (!tidio || chatState !== 'unknown') return;
    var host = document.getElementById('tidio-chat');
    var shadow = host && host.shadowRoot;
    if (!shadow) return;

    if (chatShadow !== shadow && window.MutationObserver) {
      if (chatObserver) chatObserver.disconnect();
      chatShadow = shadow;
      chatObserver = new MutationObserver(schedule);
      chatObserver.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'hidden', 'style', 'class'] });
    }

    var launcher = shadow.querySelector('button[aria-label="Open chat widget"]');
    if (launcher && launcher.getClientRects().length && window.getComputedStyle(launcher).visibility !== 'hidden') {
      chatState = 'closed';
      if (chatObserver) chatObserver.disconnect();
      applyChatVisibility();
    }
  }

  function onChatOpen() {
    chatState = 'open';
    if (chatObserver) chatObserver.disconnect();
    applyChatVisibility();
    schedule();
  }

  function onChatClose() {
    chatState = 'closed';
    applyChatVisibility();
    schedule();
    var opener = chatOpener;
    chatOpener = null;
    if (opener && opener.isConnected && mobile.matches) {
      window.requestAnimationFrame(function () {
        if (chatState === 'closed' && mobile.matches && opener.isConnected) opener.focus({ preventScroll: true });
      });
    }
  }

  function onTidioReady() {
    var api = window.tidioChatApi;
    if (!api || api === tidio || typeof api.on !== 'function' || typeof api.show !== 'function' || typeof api.hide !== 'function' || typeof api.open !== 'function') return;
    tidio = api;
    chatState = 'unknown';
    chatHidden = false;
    tidio.on('beforeOpen', onChatOpen);
    tidio.on('open', onChatOpen);
    tidio.on('close', onChatClose);
    if (!mobile.matches) tidio.show();
    observeChatState();
    updateChatButtons();
    schedule();
  }

  function openChatFrom(button) {
    if (!tidio || !mobile.matches || chatOpening) return;
    chatOpener = button;
    var sidebar = document.querySelector('.sidebar-nav--open');
    var toggle = document.querySelector('[data-action="toggle-mobile-sidebar"]');

    function openChat() {
      chatOpening = false;
      if (!tidio || !mobile.matches) return;
      chatState = 'open';
      chatHidden = false;
      tidio.show();
      updateChatButtons();
      schedule();
      tidio.open();
    }

    if (sidebar && toggle) {
      if (sidebar.contains(button)) chatOpener = toggle;
      chatOpening = true;
      var finished = false;
      var timer = 0;
      var closedEvent = 'closed.trademarkMobileSidebar.adRefinementChat';
      var afterClose = function () {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        if (window.jQuery) window.jQuery(document).off(closedEvent, afterClose);
        if (sidebar.classList.contains('sidebar-nav--open')) {
          chatOpening = false;
          schedule();
          return;
        }
        openChat();
      };
      if (window.jQuery) window.jQuery(document).one(closedEvent, afterClose);
      timer = window.setTimeout(afterClose, 350);
      toggle.click();
    } else {
      openChat();
    }
  }

  function selectedOptions(form) {
    var values = [];
    form.querySelectorAll('.single-option-selector').forEach(function (input) {
      if (input.type === 'radio' && !input.checked) return;
      values.push(input.value);
    });
    return values;
  }

  function makeProduct(element) {
    if (element.adProductRefinement) return;
    var form = element.querySelector('.product__form');
    var original = form && form.querySelector('.product__add-to-cart');
    var bar = element.querySelector('[data-ad-product-buy]');
    if (!form || !original || !bar) return;

    var button = bar.querySelector('[data-ad-product-buy-button]');
    var price = bar.querySelector('[data-ad-product-price]');
    var selection = bar.querySelector('[data-ad-product-selection]');

    function update() {
      var loading = original.classList.contains('button--loading') || original.getAttribute('aria-busy') === 'true';
      var currentPrice = text(element.querySelector('.product__price:not(.product__price--old)'));
      var quantity = form.querySelector('[name="quantity"]');
      var variant = form.querySelector('[name="id"]');
      var details = selectedOptions(form);
      details.push(selection.getAttribute('data-quantity-label') + ': ' + (quantity ? quantity.value : '1'));
      setText(price, currentPrice);
      setText(selection, details.join(' · '));
      setText(button, text(original));
      button.disabled = original.disabled || loading;
      button.classList.toggle('button--loading', loading);
      button.setAttribute('aria-busy', String(loading));
      button.setAttribute('aria-label', text(original) + ': ' + bar.getAttribute('aria-label'));
      bar.setAttribute('data-variant-id', variant ? variant.value : '');
      var rect = original.getBoundingClientRect();
      var show = mobile.matches && element.isConnected && rect.width > 0 && rect.height > 0 && rect.bottom <= 0 && !document.body.classList.contains('no-scroll') && !chatBlocksPurchaseBar();
      if (bar.hidden === show) {
        bar.hidden = !show;
        if (!show && document.activeElement === button && rect.bottom > 0 && !document.body.classList.contains('no-scroll') && !chatBlocksPurchaseBar()) {
          original.focus({ preventScroll: true });
        }
      }
    }

    button.addEventListener('click', function () {
      update();
      if (bar.hidden || button.disabled) return;
      original.click();
      update();
      schedule();
    });

    form.addEventListener('change', schedule);
    form.addEventListener('input', schedule);
    var observer = null;
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'value', 'checked', 'selected', 'aria-busy'] });
      element.querySelectorAll('.product__prices').forEach(function (prices) {
        if (!form.contains(prices)) observer.observe(prices, { subtree: true, childList: true, characterData: true });
      });
    }
    var resizeObserver = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(element);
    }
    var product = { element: element, bar: bar, update: update, observer: observer, resizeObserver: resizeObserver };
    element.adProductRefinement = product;
    products.push(product);
  }

  function initializeProducts(root) {
    enhanceRadioFocus(root);
    if (root.matches && root.matches('.product')) makeProduct(root);
    root.querySelectorAll('.product').forEach(makeProduct);
    applyChatVisibility();
    updateChatButtons();
    schedule();
  }

  function initialize() {
    if (!document.body.classList.contains('ad-refinement') || window.adRefinementChatInitialized) return;
    window.adRefinementChatInitialized = true;
    initializeProducts(document);

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-ad-product-chat]');
      if (!button || button.disabled) return;
      event.preventDefault();
      openChatFrom(button);
    });

    if (window.jQuery) {
      window.jQuery(document).on('variant_changed.product.adProductRefinement', function () {
        enhanceRadioFocus(document);
        schedule();
      });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
    var onViewportChange = function () {
      applyChatVisibility();
      schedule();
    };
    if (mobile.addEventListener) mobile.addEventListener('change', onViewportChange);
    else mobile.addListener(onViewportChange);

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('tidioChat-ready', onTidioReady);
    if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') window.tidioChatApi.on('ready', onTidioReady);

    document.addEventListener('shopify:section:load', function (event) {
      window.requestAnimationFrame(function () { initializeProducts(event.target); });
    });
    document.addEventListener('shopify:section:unload', function (event) {
      products = products.filter(function (product) {
        if (!event.target.contains(product.element)) return true;
        if (product.observer) product.observer.disconnect();
        if (product.resizeObserver) product.resizeObserver.disconnect();
        product.bar.hidden = true;
        delete product.element.adProductRefinement;
        return false;
      });
      applyChatVisibility();
      schedule();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
}());

(function () {
  function revealSelected(row) {
    if (row.scrollWidth <= row.clientWidth) return;
    var selected = row.querySelector('.ad-tiles__finish--selected, input:checked');
    var item = selected && selected.closest('.ad-tiles__finish-item, .product__color');
    if (!item) return;
    var rowRect = row.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    if (itemRect.left >= rowRect.left + 4 && itemRect.right <= rowRect.right - 4) return;
    var target = row.scrollLeft + itemRect.left - rowRect.left - (row.clientWidth - itemRect.width) / 2;
    row.scrollLeft = Math.max(0, Math.min(row.scrollWidth - row.clientWidth, target));
  }

  function revealAll() {
    document.querySelectorAll('.ad-tiles__finishes, .product__available-colors').forEach(revealSelected);
  }

  function initializeMaterialRows() {
    window.requestAnimationFrame(revealAll);
    document.addEventListener('change', function (event) {
      var row = event.target.closest && event.target.closest('.product__available-colors');
      if (row) window.requestAnimationFrame(function () { revealSelected(row); });
    });
    var scheduled = false;
    window.addEventListener('resize', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; revealAll(); });
    }, { passive: true });
    document.addEventListener('shopify:section:load', function () { window.requestAnimationFrame(revealAll); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMaterialRows);
  else initializeMaterialRows();
}());
